const steps = [
  {
    number: '01',
    label: 'Source',
    description: 'Identify 100–150 local businesses daily from Google Maps across target niches.',
    icon: 'ri-map-pin-2-line',
  },
  {
    number: '02',
    label: 'Qualify',
    description: '30-second website review to find high-fit opportunities.',
    bullets: [
      'No automation → strong fit',
      'Outdated site → clear opportunity',
      'Basic chatbot → highest intent',
    ],
    icon: 'ri-filter-3-line',
  },
  {
    number: '03',
    label: 'Clean & Prioritize',
    description: 'Remove low-quality leads, standardize data, and prioritize best-fit businesses.',
    icon: 'ri-list-check-3',
  },
  {
    number: '04',
    label: 'Load & Track',
    description: 'Import into CRM, tag by opportunity type, and organize for outreach.',
    icon: 'ri-database-2-line',
  },
  {
    number: '05',
    label: 'Outreach',
    description: 'Direct outreach focused on booking short live demos of the system.',
    icon: 'ri-send-plane-2-line',
  },
];

export default function LeadGeneration() {
  return (
    <section className="py-24 px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            How Deployments Are <span className="text-[#0EA5E9]">Generated</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto leading-relaxed">
            A structured system that consistently sources, qualifies, and converts real service
            businesses into active AI deployments.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line */}
          <div className="hidden md:block absolute left-[2.35rem] top-10 bottom-10 w-px bg-gradient-to-b from-[#0EA5E9]/40 via-[#0EA5E9]/20 to-transparent" />

          <div className="space-y-4">
            {steps.map((step, index) => (
              <div
                key={index}
                className="flex items-start gap-6 bg-gradient-to-r from-white/[0.04] to-white/[0.01] border border-white/10 rounded-2xl p-6 hover:border-[#0EA5E9]/30 transition-all duration-300"
              >
                {/* Icon circle */}
                <div className="flex-shrink-0 w-[4.5rem] h-[4.5rem] flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-[#0EA5E9]/10 border border-[#0EA5E9]/30 flex items-center justify-center">
                    <i className={`${step.icon} text-[#0EA5E9] text-lg`} />
                  </div>
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-xs font-mono text-[#0EA5E9]/60 tracking-widest">
                      STEP {step.number}
                    </span>
                    <span className="text-white font-semibold text-lg">{step.label}</span>
                  </div>
                  <p className="text-gray-300 text-sm leading-relaxed">{step.description}</p>
                  {step.bullets && (
                    <ul className="mt-3 space-y-1">
                      {step.bullets.map((bullet, bIdx) => (
                        <li key={bIdx} className="flex items-center gap-2 text-sm text-gray-400">
                          <span className="w-1.5 h-1.5 rounded-full bg-[#0EA5E9]/60 flex-shrink-0" />
                          {bullet}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer line */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 text-gray-300 text-base font-medium">
            <span>Consistent pipeline</span>
            <span className="text-[#0EA5E9]/50">→</span>
            <span>Qualified opportunities</span>
            <span className="text-[#0EA5E9]/50">→</span>
            <span>Active deployments</span>
          </div>
        </div>
      </div>
    </section>
  );
}
